import request from 'superagent';
import baseRequest2 from '../baseApi2';

interface ISmrtSubmitParams {
    file_name?: string;
    a: string;
    b: string;
    c: string;
    d: string;
    e?: string;
    f?: string;
    g?: string;
}

export const fetchUploadModelSubmit = (params: ISmrtSubmitParams): Promise<request.Response> =>
    baseRequest2(request.post('/eda/selection').set('Content-Type', 'application/json').send(JSON.stringify(params)));
